interface IValidationError {
  Error?: string
  ErrorType?: string
  FieldName: string
}

/**
 * Convert the validation errors to the redux-form errors
 * @param validationErrors
 * @returns {{}}
 */
export const formatApiValidationErrors = (validationErrors: IValidationError[]) => {
  const formErrors: { [key: string]: string } = {}
  validationErrors.forEach(err => {
    const errMsg = err.Error ? err.Error : err.ErrorType
    formErrors[err.FieldName] = `global.${errMsg}`
  })

  return formErrors
}
